var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgModuleSuppliers(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 33H22.5C30 33 33 30 33 22.5V13.5C33 6 30 3 22.5 3H13.5C6 3 3 6 3 13.5V22.5C3 30 6 33 13.5 33Z",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7 15.2998V21.5998",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.925 14.85C13.5405 14.85 14.85 13.5405 14.85 11.925C14.85 10.3096 13.5405 9 11.925 9C10.3096 9 9 10.3096 9 11.925C9 13.5405 10.3096 14.85 11.925 14.85Z",
    fill: "#D6D6FA",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7 26.9999C13.1912 26.9999 14.4 25.791 14.4 24.2999C14.4 22.8087 13.1912 21.5999 11.7 21.5999C10.2088 21.5999 9 22.8087 9 24.2999C9 25.791 10.2088 26.9999 11.7 26.9999Z",
    fill: "#D6D6FA",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3 26.9999C25.7912 26.9999 27 25.791 27 24.2999C27 22.8087 25.7912 21.5999 24.3 21.5999C22.8088 21.5999 21.6 22.8087 21.6 24.2999C21.6 25.791 22.8088 26.9999 24.3 26.9999Z",
    fill: "#D6D6FA",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.82 15.2998C12.225 16.8748 13.665 18.0448 15.36 18.0298L18.45 18.0148C20.805 17.9998 22.815 19.5148 23.55 21.6298",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleSuppliers);
export default __webpack_public_path__ + "static/media/module-suppliers.698abbb2.svg";
export { ForwardRef as ReactComponent };